"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconTwitter = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var React = __importStar(require("react"));

exports.IconTwitter = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return (0, jsx_runtime_1.jsx)("svg", _objectSpread(_objectSpread({
    width: "40",
    height: "32",
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef,
    children: (0, jsx_runtime_1.jsx)("path", {
      d: "M12.3849 32C27.2461 32 35.3746 19.6876 35.3746 9.01031C35.3746 8.66059 35.3746 8.31246 35.3509 7.9659C36.9323 6.8221 38.2973 5.40587 39.3821 3.78352C37.9074 4.43695 36.3431 4.86547 34.7413 5.05477C36.428 4.04499 37.6904 2.45677 38.2936 0.585691C36.7075 1.52685 34.9723 2.19014 33.1629 2.54692C31.9446 1.25154 30.3334 0.393771 28.5786 0.106353C26.8237 -0.181066 25.0231 0.117889 23.4553 0.956954C21.8874 1.79602 20.6399 3.12842 19.9056 4.74797C19.1713 6.36751 18.9913 8.18392 19.3933 9.9161C16.1809 9.75505 13.0383 8.92025 10.1695 7.46589C7.30063 6.01152 4.7697 3.9701 2.74099 1.47415C1.70775 3.2529 1.39129 5.35858 1.85604 7.36247C2.3208 9.36635 3.53182 11.1178 5.24254 12.2601C3.9567 12.222 2.6989 11.8751 1.57528 11.2488C1.57528 11.2819 1.57528 11.3165 1.57528 11.3512C1.57579 13.2167 2.22156 15.0245 3.40306 16.4682C4.58455 17.9118 6.22903 18.9023 8.05758 19.2717C6.86803 19.5961 5.61995 19.6435 4.40922 19.4103C4.92553 21.0158 5.93073 22.4198 7.28422 23.4259C8.63772 24.4319 10.2718 24.9898 11.958 25.0215C9.09685 27.2701 5.56242 28.4908 1.92342 28.4871C1.28055 28.4859 0.638311 28.447 0 28.3705C3.69504 30.7418 7.99443 31.9996 12.3849 31.9937",
      fill: color
    }, void 0)
  }), void 0);
});